import { Box, styled } from '@mui/material';

export const ButtonsContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'barHeight' &&
    prop !== 'fixedAtBottom' &&
    prop !== 'isSettingsQuestionnaire',
})(({ theme, fixedAtBottom, isSettingsQuestionnaire }) => ({
  height: fixedAtBottom && '64px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  position: isSettingsQuestionnaire
    ? 'relative'
    : fixedAtBottom
      ? 'absolute'
      : 'unset',
  bottom: 0,
  left: fixedAtBottom && '50%',
  transform: fixedAtBottom && 'translateX(-50%)',
  backgroundColor: theme.palette.colors.primaryBackground,
  justifyContent: isSettingsQuestionnaire && 'flex-end',

  [theme.breakpoints.up('lg')]: {
    left: 'auto',
    transform: 'none',
    right: 0,
    marginTop: isSettingsQuestionnaire && '16px',
  },
}));
